import React, { useEffect, useState } from 'react';
import { Collapse, CollapseProps, Table, Checkbox } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import RegistrationListItemDTO from 'src/models/generated/RegistrationListItemDTO';
import moment from 'moment';

export interface RegistrationTableProps {
  data?: RegistrationListItemDTO[];
  loading?: boolean;
}

const RegistrationTable: React.FC<RegistrationTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>['0']>(['1']);
  const tableData = props.data ?? [];
  const minValidYear = 2000;

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<RegistrationListItemDTO>[] = [
    TableColumnBuilder.Create<RegistrationListItemDTO>('created', 'Created')
      .Width(180)
      .AddSorter('Date')
      .AddEnumFilterer(Array.from(new Set(tableData.map(x => moment(x.created)).filter(x => x.isValid() && x.year() > minValidYear).map(x => x.format('L') ?? ''))), 'Date')
      .AddRenderer('ShortDate')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('lastActivity', 'Last Activity')
      .Width(180)
      .AddSorter('Date')
      .AddEnumFilterer(Array.from(new Set(tableData.map(x => moment(x.lastActivity)).filter(x => x.isValid() && x.year() > minValidYear).map(x => x.format('L') ?? ''))), 'Date')
      .AddRenderer('ShortDate')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('pCName', 'PC Name')
      .Width(200)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('publicIP', 'Public IP')
      .Width(300)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('productCode', 'Product Code')
      .Width(300)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .DefaultSortOrder('ascend')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('version', 'Version')
      .Width(300)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<RegistrationListItemDTO>('disable', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='registration-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key="1" header={<h3 className='table-title'>Registration</h3>}>
        <Table
          rowKey={NameOf<RegistrationListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default RegistrationTable;
